/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Days = null | null | null | null | null | null | null;

export const Days = {
    NUMBER_null: null as Days,
    NUMBER_null2: null as Days,
    NUMBER_null3: null as Days,
    NUMBER_null4: null as Days,
    NUMBER_null5: null as Days,
    NUMBER_null6: null as Days,
    NUMBER_null7: null as Days
};

